const SESSION_TOKEN_KEY = "march-madness-pool:session-token";

function readBody(text) {
  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch {
    return {};
  }
}

async function request(path, options = {}) {
  const headers = new Headers(options.headers || {});
  headers.set("accept", "application/json");

  if (options.body !== undefined) {
    headers.set("content-type", "application/json; charset=utf-8");
  }
  if (options.token) {
    headers.set("authorization", `Bearer ${options.token}`);
  }

  const response = await fetch(path, {
    method: options.method || "GET",
    headers,
    body: options.body !== undefined ? JSON.stringify(options.body) : undefined,
    signal: options.signal,
  });

  const text = await response.text();
  const payload = readBody(text);

  if (!response.ok) {
    throw new Error(payload?.error || "Request failed.");
  }

  return payload;
}

export function getStoredSessionToken() {
  try {
    return String(window.localStorage.getItem(SESSION_TOKEN_KEY) || "").trim();
  } catch {
    return "";
  }
}

export function setStoredSessionToken(token) {
  try {
    window.localStorage.setItem(SESSION_TOKEN_KEY, String(token || "").trim());
  } catch {}
}

export function clearStoredSessionToken() {
  try {
    window.localStorage.removeItem(SESSION_TOKEN_KEY);
  } catch {}
}

export function fetchBootstrap(token = "") {
  return request("/api/bootstrap", { token });
}

export function createSession(displayName, pin = "") {
  return request("/api/session", {
    method: "POST",
    body: { displayName, pin },
  });
}

export function lookupDisplayName(displayName, options = {}) {
  const params = new URLSearchParams({
    displayName: String(displayName || ""),
  });

  return request(`/api/session/lookup?${params.toString()}`, {
    signal: options.signal,
  });
}

export function savePicks(teamIds, token) {
  return request("/api/picks", {
    method: "POST",
    body: { teamIds },
    token,
  });
}

export function refreshBracket(token = "") {
  return request("/api/sync", {
    method: "POST",
    token,
  });
}

export function refreshDraftKings(token = "") {
  return request("/api/refresh-dk", {
    method: "POST",
    token,
  });
}

export function setPoolLock(locked, token = "") {
  return request("/api/admin/pool/lock", {
    method: "POST",
    body: { locked: locked === true },
    token,
  });
}

export function clearAllPicks(token = "") {
  return request("/api/admin/picks/clear-all", {
    method: "POST",
    token,
  });
}

export function setUserPaid(userId, paid, token = "") {
  return request(`/api/admin/users/${encodeURIComponent(String(userId || ""))}/paid`, {
    method: "POST",
    body: { paid: paid === true },
    token,
  });
}

export function deleteUser(userId, token = "") {
  return request(`/api/admin/users/${encodeURIComponent(String(userId || ""))}`, {
    method: "DELETE",
    token,
  });
}

export function setAccountPin(pin, token = "") {
  return request("/api/me/pin", {
    method: "POST",
    body: { pin },
    token,
  });
}
